import { render, staticRenderFns } from "./matchDetail.vue?vue&type=template&id=07f9dcfc&scoped=true&"
import script from "./matchDetail.vue?vue&type=script&lang=js&"
export * from "./matchDetail.vue?vue&type=script&lang=js&"
import style0 from "./matchDetail.vue?vue&type=style&index=0&id=07f9dcfc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f9dcfc",
  null
  
)

export default component.exports